<template>
    <span 
        v-if="temDocumento()"
    >
        <span class="text-primary ml-1">
            <i
                class="fa fa-file fa-lg icon-button"
                title="Documentação de validação"
                @click.stop="toDetalhar()"
            ></i>
        </span>
    </span>    
</template>

<script>
export default {
    props: {
        etapa: {
            type: Object
        }
    },

    methods: {
        toDetalhar() {
            window.open(this.etapa.urlDocumentacaoValidacao)
        },

        temDocumento() {
            return this.etapa.urlDocumentacaoValidacao != null
        }
    }
}
</script>